import { Component, OnInit } from "@angular/core";
import {
  Store,
  WorkoutsState,
  AutoUnsubscribe,
  Subscription,
  Fields,
  Types,
  combineLatest,
} from "../store";
import { ActivatedRoute, Router } from "@angular/router";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";
import { WorkoutService, AlertService } from "../../../services";
import { InjuryService } from "../../../services/injury.service ";
import { AmChart, AmChartsService } from "@amcharts/amcharts3-angular";

@Component({
  selector: "app-team-all-injuries",
  templateUrl: "./team-all-injuries.component.html",
  styleUrls: ["./team-all-injuries.component.css"],
})
@AutoUnsubscribe
export class TeamAllInjuriesComponent implements OnInit {
  sub: Subscription;
  plan = null;
  workoutPlanID: number;
  firstTeamPlayers = [];

  selectedWorkout = null;
  formOpened: boolean;

  confirmOpened: boolean;
  public links: { title: string; url: any; }[] = [];

  public isMonthlyInjuryChartLoaded: boolean = false;

  constructor(
    private store: Store<WorkoutsState>,
    private route: ActivatedRoute,
    private router: Router,
    private spinner: Ng4LoadingSpinnerService,
    private _service: InjuryService,
    private as: AlertService,
    private AmCharts: AmChartsService
  ) {}

  ngOnInit() {
    const teamID = +localStorage.getItem("teamId");
    const clubID = +localStorage.getItem("clubId");

    this.loadAllInjuredPlayersByTeamID(teamID);
    this.loadChartDataByTeamID(teamID, clubID);

    this.links = [
      { title: 'TEAMS LIST', url: '/team-admin/my-teams' },
      { title: 'TEAM PLAYERS LIST', url: null }
    ];
  }

  loadChartDataByTeamID(teamID: number, clubID: number) {
    this._service.loadAllChartDataByTeamID(teamID, clubID).subscribe(result => {
      console.log("loadChartDataByTeamID =====> ", result);
      this.chartData = result;
      this.generateReportGraph();

    }, error => {
    })
  }




  loadAllInjuredPlayersByTeamID(teamID: number) {
    this.spinner.show();
    this._service.loadAllInjuredPlayersByTeamID(teamID).subscribe(
      (result: any) => {
        console.log("result  => ", result);
        this.firstTeamPlayers = result;
        this.isMonthlyInjuryChartLoaded = true;
        this.spinner.hide();
      },
      (error) => {
        this.spinner.hide();
        console.log("Could not load all injuries");
      }
    );
  }

  private chartData: any;
  private chart: AmChart;
  generateReportGraph() {
    this.chart = this.AmCharts.makeChart("chartdiv", {
      type: "serial",
      startDuration: 1,
      theme: "none",
      legend: {
        horizontalGap: 10,
        maxColumns: 1,
        position: "right",
        useGraphSettings: true,
        markerSize: 10,
      },
      dataProvider: this.chartData,
      valueAxes: [
        {
          stackType: "regular",
          axisAlpha: 0.3,
          gridAlpha: 0,
        },
      ],
      graphs: [
        {
          balloonText:
            "<b>[[title]]</b><br><span style='font-size:14px'>[[category]]: <b>[[value]]</b></span>",
          fillAlphas: 0.8,
          labelText: "[[value]]",
          lineAlpha: 0.3,
          title: "Healthy",
          type: "column",
          color: "black",
          fillColors: "#6cbceb",
          valueField: "healthy",
        },
        {
          balloonText:
            "<b>[[title]]</b><br><span style='font-size:14px'>[[category]]: <b>[[value]]</b></span>",
          fillAlphas: 0.8,
          labelText: "[[value]]",
          lineAlpha: 0.3,
          title: "Day To Day",
          type: "column",
          color: "black",
          fillColors: "#8bddd6",
          valueField: "daytoday",
        },
        {
          balloonText:
            "<b>[[title]]</b><br><span style='font-size:14px'>[[category]]: <b>[[value]]</b></span>",
          fillAlphas: 0.8,
          labelText: "[[value]]",
          lineAlpha: 0.3,
          title: "In Therapy",
          type: "column",
          color: "black",
          fillColors: "#668e8c",
          valueField: "intherapy",
        },
        {
          balloonText:
            "<b>[[title]]</b><br><span style='font-size:14px'>[[category]]: <b>[[value]]</b></span>",
          fillAlphas: 0.8,
          labelText: "[[value]]",
          lineAlpha: 0.3,
          title: "Injured",
          type: "column",
          color: "black",
          fillColors: "#9f9fa0",
          valueField: "injured",
        }
      ],
      categoryField: "month",
      categoryAxis: {
        gridPosition: "start",
        axisAlpha: 0,
        gridAlpha: 0,
        position: "left",
      },
      export: {
        enabled: true,
      },
    });
  }

  showPlayerInjuries(player) {
    this.router.navigate(['/team-injury/team-player-injuries/'+player.teamID+'/'+player.playerID]);
  }

  get allChecked() {
    return (
      this.firstTeamPlayers &&
      this.firstTeamPlayers.length &&
      this.firstTeamPlayers.every((p) => p.checked)
    );
  }

  set allChecked(checked: boolean) {
    this.firstTeamPlayers.forEach((x) => (x.checked = checked));
  }

  get selectedWorkouts() {
    return this.firstTeamPlayers.filter((x) => x.checked);
  }

  onDelete() {
    if (this.selectedWorkouts.every((x) => !x.hasCompletedPlayer)) {
      this.confirmOpened = true;
    } else {
      this.as.warn(
        `Heads Up! This work out can not be deleted as a player has completed this workout`
        // + this.selectedWorkouts.filter(x => x.hasCompletedPlayer).map(x => `<p>${x.name}</p>`).join('')
      );
    }
  }

  // onConfirmDelete() {
  //   this.confirmOpened = false;
  //   this.spinner.show();
  //   this.ws.archiveWorkouts(this.selectedWorkouts.map(x => x.workoutID)).subscribe(
  //     (res) => {
  //       this.as.success(res);
  //       this.getWorkouts();
  //     },
  //     () => {
  //       this.spinner.hide();
  //       this.as.error('Something went wrong.');
  //     }
  //   );
  // }

  closeOverlay(event = null) {
    this.selectedWorkout = null;
    this.formOpened = false;
    if (event === true) {
      this.store.dispatch({ type: Types.GetWorkoutPlans });
    } else if (event) {
      event.stopPropagation();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/team-injuries/team-injuries-list/team-all-injuries.component.ts